import { ApiUrlPrepare } from "@lib/helpers/ApiHelper";
import { API } from "@lib/services/http";
import { ProviderTransactionConfig } from "@lib/types";
import { ApiParams, PaginationType } from "@lib/types/Api";
import { Provider, ProviderCustomerMatrix } from "@lib/types/Provider";

export const apiGetProvider = async (providerId: string) => {
  const url = `/payment-hub-provider/${providerId}`;
  return API.get<Provider>(url);
};

export const apiAddProvider = async (data: Provider) => {
  return API.post<Provider>(`/payment-hub-provider`, data);
};

export const apiDeleteProvider = async (data: Provider) => {
  return API.delete<null>(`/payment-hub-provider/${data.id}`);
};

export const apiUpdateProvider = async (data: Partial<Provider>) => {
  const { id, ...rest } = data;
  return API.patch<Provider>(`/payment-hub-provider/${id}`, rest);
};

export const apiGetProviders = async <T extends ApiParams>(params: T) => {
  const url = ApiUrlPrepare({ params, url: `/payment-hub-provider` });
  return API.get<PaginationType<Provider>>(url);
};

//
// Provider Customer Matrix
export const apiAddProviderCustomerMatrix = async (
  data: ProviderCustomerMatrix,
) => {
  return API.post<ProviderCustomerMatrix>(`/provider-customer-matrix/`, data);
};

export const apiUpdateProviderCustomerMatrix = async (
  data: ProviderCustomerMatrix,
) => {
  const { id, ...rest } = data;
  return API.patch<ProviderCustomerMatrix>(
    `/provider-customer-matrix/${id}`,
    rest,
  );
};

export const apiDeleteProviderCustomerMatrix = async (
  data: ProviderCustomerMatrix,
) => {
  return API.delete<null>(`/provider-customer-matrix/${data.id}`);
};

export const apiGetProviderCustomerMatrix = async (matrixId: string) => {
  const url = `/provider-customer-matrix/${matrixId}`;
  return API.get<ProviderCustomerMatrix>(url);
};

export const apiGetProviderCustomerMatrices = async <T extends ApiParams>(
  params: T,
) => {
  const url = ApiUrlPrepare({ params, url: `/provider-customer-matrix` });
  return API.get<PaginationType<ProviderCustomerMatrix>>(url);
};

export const apiGetProviderTransactionConfigs = async <T extends ApiParams>(
  params: T,
) => {
  const url = ApiUrlPrepare({ params, url: `/provider-transaction-config` });
  return API.get<PaginationType<ProviderTransactionConfig>>(url);
};

export const apiGetProviderTransactionConfig = async (configId: string) => {
  const url = `/provider-transaction-config/${configId}`;
  return API.get<ProviderTransactionConfig>(url);
};

export const apiAddProviderTransactionConfig = async (
  data: Partial<ProviderTransactionConfig>,
) => {
  return API.post<ProviderTransactionConfig>(
    `/provider-transaction-config`,
    data,
  );
};

export const apiUpdateProviderTransactionConfig = async (
  data: Partial<ProviderTransactionConfig>,
) => {
  const { id, ...rest } = data;
  return API.patch<ProviderTransactionConfig>(
    `/provider-transaction-config/${id}`,
    rest,
  );
};

export const apiDeleteProviderTransactionConfig = async (
  data: Pick<ProviderTransactionConfig, "id">,
) => {
  return API.delete<null>(`/provider-transaction-config/${data.id}`);
};
